// extracted by mini-css-extract-plugin
module.exports = {"container":"AlertBox_container__2hUMF","content":"AlertBox_content__1o87E","image":"AlertBox_image__3RGc9"};